const controllers = ref<AbortController[]>([])

export const useAbortController = () => {
  const addController = (controller: AbortController) => {
    controllers.value.push(controller)
  }

  const removeController = (controller: AbortController) => {
    controllers.value = controllers.value.filter((c) => c !== controller)
  }

  const cancelAllRequests = () => {
    controllers.value.forEach((controller) => controller.abort())
    controllers.value = []
  }

  return {
    addController,
    removeController,
    cancelAllRequests
  }
}
